var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { BaseButton } from "../base-button/BaseButton";
import { IdButtonType } from "../base-button/IdButtonType";
export var ButtonInfoSmall = React.memo(function (_a) {
    var onClick = _a.onClick, soundId = _a.soundId, props = __rest(_a, ["onClick", "soundId"]);
    return (React.createElement(BaseButton, __assign({ name: IdStyles.ButtonInformation, styleId: IdButtonType.ButtonSquareExtraSmall, onClick: onClick }, props)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonInfoSmall.tsx
// module id = 169
// module chunks = 3